import { createFileRoute } from '@tanstack/react-router'
import { TeamMembers } from '@/common/components/team-members/TeamMembers'

export const Route = createFileRoute('/manager/team')({
  component: TeamMembers,
})
